module.exports = __webpack_public_path__ + "static/media/img5.fc1b413f.jpg";